import { createRouter, RouterHistory } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import { AppLoadingSurface } from "./components/AppLoadingSurface";

export function getRouter(history: RouterHistory) {
  const router = createRouter({
    routeTree,
    history,
    context: {},
    defaultPendingComponent: AppLoadingSurface,
    defaultPendingMs: 0,
    defaultPendingMinMs: 0,
  });
  // Bootstrap needs immediate feedback. Once a page has resolved, give navigation
  // the router's usual pending delay: a zero-delay root fallback unmounts the
  // shared sidebar before its saved width can transition to the next section.
  const unsubscribe = router.subscribe("onResolved", () => {
    router.update({ defaultPendingMs: 1000 });
    unsubscribe();
  });
  return router;
}

export type AppRouter = ReturnType<typeof getRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}
